
















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Footer extends Vue {
	name = "footer";

	get version() {
		return process.env.VUE_APP_VERSION;
	}
}
